import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { GET_CHECK_LIST } from "../apiRoutes";

// Response item type
export interface ChecklistItem {
  _id: string;
  kitName: string;
  tlmName: string;
  quantity: number;
  included: boolean;
  dateOfInclusion: string | null;
  comments: string;
  tlmMasterId: string;
  schoolId: string;
  kitType: string;
}

// Full response type
export interface ChecklistInventoryResponse {
  status: number;
  error: boolean;
  count: number;
  issues: any[];
  data: ChecklistItem[];
  message: string;
}

// ✅ Fetch function
const fetchInventoryChecklistSetup = async (schoolId: string, params?: FieldValues) => {
  const response = await axiosAuth.get<ChecklistInventoryResponse>(
    `${GET_CHECK_LIST}${schoolId}`, // 👈 append schoolId to endpoint
    { params }
  );
  return response.data;
};

// ✅ React Query hook
const useGetChecklistInventory = (
  schoolId: string,
  params?: FieldValues,
  queryOptions?: UseQueryOptions<
    ChecklistInventoryResponse,
    Error,
    ChecklistInventoryResponse,
    ["inventoryChecklist", string, FieldValues | undefined]
  >
) =>
  useQuery<
    ChecklistInventoryResponse,
    Error,
    ChecklistInventoryResponse,
    ["inventoryChecklist", string, FieldValues | undefined]
  >({
    queryKey: ["inventoryChecklist", schoolId, params],
    queryFn: () => fetchInventoryChecklistSetup(schoolId, params),
    ...queryOptions,
  });

export default useGetChecklistInventory;
